import { render, staticRenderFns } from "./NotifyPopup.vue?vue&type=template&id=31bc1c3c&scoped=true&"
import script from "./NotifyPopup.vue?vue&type=script&lang=ts&"
export * from "./NotifyPopup.vue?vue&type=script&lang=ts&"
import style0 from "./NotifyPopup.vue?vue&type=style&index=0&id=31bc1c3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bc1c3c",
  null
  
)

export default component.exports